module.exports = "/img/14.ba8551.webp";